import { GetterTree } from "vuex";
import { RootState } from "@/store/types";
import { RenderPostStatistic, RenderState } from "@/services/render/types";

export const getters: GetterTree<RenderState, RootState> = {
    getRenderStatistics(state): RenderPostStatistic[] {
        return state.postStatistics;
    },
    getCurrentSolutionTimezoneId(state): string {
        return state.currentSolutionTimezoneId;
    },
    getAllowedOrigins(state): string[] {
        return state.allowedOrigins;
    }
};
